import { Box, createTheme, Link, Typography } from '@mui/material';
import React, { FC, useContext } from 'react';
import { constants } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';
import SurveyUtils from '../../shared/SurveyUtils';
import Autolink from '../Autolink/Autolink';

interface Props {
  companyLogo: string;
  primary: string;
  platform: string;
  platformUrl: string;
  platformName: string;
  secondary: string;
  companyWebsiteUrl: string;
  customFont: string;
  title?: string;
  outroText?: string;
  companyName?: string;
  feedbackActive?: boolean;
}

const PositiveFeedback: FC<Props> = ({
  primary,
  platform,
  secondary,
  customFont,
  platformUrl,
  platformName,
  title,
  outroText,
}) => {
  const theme = createTheme();
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: primary,
          fontWeight: 'bold',
          fontFamily: customFont,
          textAlign: 'center',
          mb: theme.spacing(4),
        }}
      >
        {title}
      </Typography>
      {outroText && (
        <Typography
          variant="h5"
          sx={{
            color: secondary,
            fontWeight: 'light',
            mt: theme.spacing(1),
            fontFamily: customFont,
          }}
        >
          <Autolink text={outroText} />
        </Typography>
      )}
      {platformUrl && (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: 'fit-content',
              margin: '0 auto',
              mb: 4,
            }}
          >
            <Link
              href={platformUrl}
              underline={'none'}
              target={'_blank'}
            >
              <Typography
                variant="h5"
                sx={{
                  color: '#fff',
                  backgroundColor: primary,
                  padding: '.2em .5em',
                  fontWeight: 'light',
                  borderRadius: '4px',
                  boxShadow:
                    'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;',
                  mt: theme.spacing(4),
                  fontFamily: customFont,
                  '&:hover': {
                    opacity: 0.9,
                  },
                }}
              >
                {`${t('please_rate_us')} ${SurveyUtils.getName(platformName)}!`}
              </Typography>
            </Link>
            <Link
              href={platformUrl}
              variant="body1"
              underline="none"
              target="_blank"
              sx={{
                color: primary,
                fontWeight: 'bold',
                fontFamily: customFont,
                textAlign: 'center',
              }}
            >
              <Box
                component={'img'}
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxWidth: '256px',
                  minHeight: '64px',
                  mt: theme.spacing(2),
                }}
                src={constants.platform_logos[platform.toLowerCase()]}
                alt={`${platform} Logo`}
              />
            </Link>
          </Box>
        </>
      )}
    </Box>
  );
};

export default PositiveFeedback;
